/* eslint-disable */
/* This file is auto-generated. Do not edit this file directly. */

/*
 * This file contains an index of all the routes in the app. It can help to
 * catch broken links at build time. If a route is moved or removed, any
 * references to its original key in this file will raise an error.
 */

export const pages = {
  ControllersList: '/',
  CLI: '/cli',
  CLIv2: '/cliv2/:uuid',
  CompaniesList: '/companies',
  CompanyNetworks: '/companies/:companyName/networks',
  CompanyUsers: '/companies/:companyName/users',
  ControllerDetails: '/controllers/:controllerName',
  ControllerClientsList: '/controllers/:controllerName/clients',
  ControllerConfig: '/controllers/:controllerName/config',
  ControllerDevicesList: '/controllers/:controllerName/devices',
  ControllerDeviceClients: '/controllers/:controllerName/devices/:deviceName/clients',
  ControllerIncidentsList: '/controllers/:controllerName/incidents',
  ControllerLogs: '/controllers/:controllerName/logs',
  ControllerServicePlans: '/controllers/:controllerName/plans',
  ControllerState: '/controllers/:controllerName/state',
  ControllerStats: '/controllers/:controllerName/stats',
  ControllerSwitchesList: '/controllers/:controllerName/switches',
  VPNListPage: '/controllers/:controllerName/vpn',
  NosVersionsList: '/nos-versions',
} as const;